import React from "react";
import { Button, Card, Col, Empty, Form, Row } from "antd";
import { useForm } from "react-hook-form";
import { useGetConfig } from "../api/useGetConfigurations";

import { DynamicFields } from "../../DynamicFields";
import { usePostLeaseConfiguration } from "../hooks/usePostLeaseConfiguration";
import { getBookingDetail } from "../../../modules/BookingForm/ducks/actions";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../redux/store";
import { useSelector } from "react-redux";
import { useTransFormLeaseConfigData } from "../hooks/useTransFormLeaseConfigData";
import { useParams } from "react-router-dom";

interface LeaseConfigProps {
  title?: string;
  enabled?: boolean;
  onToggle?: (value: boolean) => void;
  leaseId?: string;
  visible?: boolean;
}

const LeaseConfiguration: React.FC<LeaseConfigProps> = ({
  title = "Lease Configuration",
  enabled = false,
  onToggle,
  visible,
}) => {
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
    watch,
  } = useForm({ defaultValues: {} });
  const dispatch = useDispatch<AppDispatch>();
  const { data, isLoading, error } = useGetConfig();
  const defaultProps = { control: control, setValue: setValue };
  let { bookingDetails } = useSelector((state: any) => state.newBooking);

  const { leaseId = bookingDetails.leaseId } = useParams();
  const { postLeaseConfiguration, loading } = usePostLeaseConfiguration(leaseId);
  let finalData = useTransFormLeaseConfigData(bookingDetails?.leaseConfig, data);

  const submitData = async (values) => {
    try {
      await postLeaseConfiguration(values);
      !loading && (await dispatch(getBookingDetail(leaseId)));
      onToggle && onToggle(false);
    } catch (error) {
      console.log(error, "error in lease config");
    }
  };

  if (finalData.length === 0 && !isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxHeight: "50vh",
          minHeight: "50vh",
          overflow: "auto",
        }}
      >
        <Empty description="No Configuration Available" />
      </div>
    );
  }
  return (
    <Form layout="vertical" className="bf-main" onFinish={handleSubmit(submitData)}>
      <Card
        loading={isLoading || loading}
        className="lease-config-card"
        style={
          finalData.length > 0
            ? { maxHeight: "80vh", minHeight: "80vh", overflow: "auto" }
            : { minHeight: "50vh", overflow: "auto" }
        }
      >
        {
          <>
            <Row gutter={16}>
              <DynamicFields template={finalData} {...defaultProps} errors={errors} colSpan={12} />
              <Col span={24}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "30px",
                  }}
                >
                  <Button
                    onClick={() => onToggle && onToggle(false)}
                    type="default"
                    size="large"
                    className="csv_publish"
                  >
                    Back
                  </Button>
                  <Button disabled={loading} htmlType="submit" type="primary" size="large" className="csv_publish">
                    {loading ? "Loading..." : "Submit"}
                  </Button>
                </div>
              </Col>
            </Row>
          </>
        }
      </Card>
    </Form>
  );
};

export default LeaseConfiguration;
